module.exports = __webpack_public_path__ + "img/disc.ee361173.svg";